// extracted by mini-css-extract-plugin
module.exports = {"All":"Footer_All__2SKw3","Footer":"Footer_Footer__238hM","FooterInner":"Footer_FooterInner__1PwkV"};